import { Directive, ElementRef, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { ReferenceDataOptionLists } from '../constants/reference-data-option-lists';

const incompleteClass = 'recommendation-incomplete';
const issuedClass = 'recommendation-issued';
const acceptedClass = 'recommendation-accepted';
const rejectedClass = 'recommendation-rejected';
const expiredClass = 'recommendation-expired';

@Directive({
  selector: '[boiCategorizeRecommendationStatus]'
})
export class CategorizeRecommendationStatusDirective implements OnInit, OnChanges {
  private readonly categories: Array<string> = [];

  @Input('boiCategorizeRecommendationStatus') recommendationStatus: string;

  constructor(private readonly hostElement: ElementRef, private readonly renderer: Renderer2) {
    this.initializeCategories();
  }

  ngOnInit(): void {
    this.addCaseStatusCssClass();
  }

  ngOnChanges(): void {
    this.addCaseStatusCssClass();
  }

  private addCaseStatusCssClass(): void {
    const cssClass = this.categories[this.recommendationStatus.toLocaleUpperCase()];
    this.categories.forEach((categorieCssClass) => {
      this.renderer.removeClass(this.hostElement.nativeElement, categorieCssClass);
    });

    this.renderer.addClass(this.hostElement.nativeElement, cssClass);
  }

  private initializeCategories(): void {
    this.categories[ReferenceDataOptionLists.RecommendationStatusAdviceIncomplete.toUpperCase()] = incompleteClass;
    this.categories[ReferenceDataOptionLists.RecommendationStatusAdviceIssued.toUpperCase()] = issuedClass;
    this.categories[ReferenceDataOptionLists.RecommendationStatusAdviceAccepted.toUpperCase()] = acceptedClass;
    this.categories[ReferenceDataOptionLists.RecommendationStatusAdviceRejected.toUpperCase()] = rejectedClass;
    this.categories[ReferenceDataOptionLists.RecommendationStatusAdviceExpired.toUpperCase()] = expiredClass;
  }
}
